module.exports = __webpack_public_path__ + "img/growth-analytics.f26d2c58.svg";